var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6622 1.47951V4.21467L7.19345 5.15217L7.6622 6.08967V17.6373L2.13892 17.1686V6.08967L2.60767 5.15217L2.13892 4.21467V1.47951C2.13892 1.34404 2.2486 1.23389 2.38407 1.23389H7.41657C7.55204 1.23389 7.6622 1.34404 7.6622 1.47951Z",
    fill: "#FF7373"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6622 1.47951V4.21467L7.19345 5.15217L7.6622 6.08967V20.6148H2.13892V19.0679H5.74126C6.25829 19.0679 6.67782 18.6484 6.67782 18.1314V1.47951C6.67782 1.34404 6.56767 1.23389 6.4322 1.23389H7.41657C7.55204 1.23389 7.6622 1.34404 7.6622 1.47951Z",
    fill: "#E73E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6622 17.1686V19.9581L2.13892 20.4269V17.1686H7.6622Z",
    fill: "#ABB7C0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13892 4.21472H7.6622V6.08972H2.13892V4.21472Z",
    fill: "#FFF3D3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6778 4.21472H7.66217V6.08972H6.6778V4.21472Z",
    fill: "#FFCF54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.67782 17.1686H7.6622V19.9581H2.13892V19.068H5.74126C6.25829 19.068 6.67782 18.6484 6.67782 18.1314V17.1686Z",
    fill: "#46545F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.08691 7.89954C3.89276 7.89954 3.73535 8.05694 3.73535 8.2511V15.1095C3.73535 15.3036 3.89276 15.461 4.08691 15.461C4.28107 15.461 4.43848 15.3036 4.43848 15.1095V8.2511C4.43848 8.05694 4.28107 7.89954 4.08691 7.89954Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71393 8.98499C5.51977 8.98499 5.36237 9.14239 5.36237 9.33655V14.024C5.36237 14.2182 5.51977 14.3756 5.71393 14.3756C5.90808 14.3756 6.06549 14.2182 6.06549 14.024V9.33655C6.06549 9.14239 5.90813 8.98499 5.71393 8.98499Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5315 15.617L20.6409 16.2325L19.2867 17.1686L16.223 17.1423L13.2755 6.88326L13.4723 5.93873L12.7575 5.08139L11.9958 2.42967C11.9587 2.30076 12.0333 2.16623 12.1622 2.12967L15.7631 1.09514L17.0044 0.738418C17.1333 0.701387 17.2673 0.775449 17.3044 0.904355L18.0665 3.55654L17.8448 4.41623L18.584 5.35795L21.5315 15.617Z",
    fill: "#62CDB4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5316 15.617L20.6409 16.2325L16.3556 1.42232C16.2825 1.16873 16.0172 1.02201 15.7631 1.09514L17.0044 0.738418C17.1333 0.701387 17.2673 0.775449 17.3044 0.904355L18.0666 3.55654L17.8448 4.41623L18.5841 5.35795L21.5316 15.617Z",
    fill: "#39B195"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5841 5.35792L17.5781 5.64714L13.2755 6.88324L12.7575 5.08136L17.0569 3.84667L18.0666 3.55652L18.5841 5.35792Z",
    fill: "#FFF3D3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1747 18.7347L17.0995 20.1925L16.7934 19.1275L16.223 17.1424L20.5448 15.9007L21.5316 15.6171L22.3411 18.4343C22.3776 18.5632 22.3036 18.6977 22.1747 18.7347Z",
    fill: "#ABB7C0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1746 18.7347L17.0995 20.1925L16.7934 19.1275L20.1534 18.1118C20.6789 17.9528 20.9789 17.4007 20.8265 16.8733L20.5448 15.9007L21.5315 15.6171L22.3411 18.4343C22.3776 18.5632 22.3036 18.6977 22.1746 18.7347Z",
    fill: "#46545F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1406 8.2606C16.087 8.07399 15.8922 7.96609 15.7056 8.01976C15.519 8.07338 15.4112 8.2681 15.4648 8.45471L17.3586 15.0464C17.4029 15.2006 17.5435 15.3009 17.6963 15.3009C17.7285 15.3009 17.7612 15.2965 17.7935 15.2872C17.9802 15.2336 18.088 15.0389 18.0344 14.8523L16.1406 8.2606Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2985 13.3597L18.0041 8.85447C17.9505 8.66787 17.7558 8.55996 17.5691 8.61363C17.3825 8.66726 17.2747 8.86197 17.3283 9.04858L18.6227 13.5538C18.667 13.7081 18.8076 13.8084 18.9604 13.8084C18.9926 13.8084 19.0252 13.804 19.0576 13.7947C19.2443 13.7411 19.3521 13.5463 19.2985 13.3597Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 3.36576V19.9581H7.66217V3.10889H11.9911C12.1331 3.10889 12.248 3.22373 12.248 3.36576Z",
    fill: "#FFCF54"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 3.36576V19.9581H11.2636V3.36576C11.2636 3.22373 11.1487 3.10889 11.0067 3.10889H11.9911C12.1331 3.10889 12.248 3.22373 12.248 3.36576Z",
    fill: "#FFA402"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 17.1686V20.4269L7.66217 19.9581V17.1686H12.248Z",
    fill: "#ABB7C0"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2636 17.1686H12.248V19.9581H6.72467V19.068H10.327C10.844 19.068 11.2636 18.6484 11.2636 18.1314V17.1686Z",
    fill: "#46545F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66217 6.08972H12.248V7.96472H7.66217V6.08972Z",
    fill: "#FFF3D3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2635 6.08972H12.2479V7.96472H11.2635V6.08972Z",
    fill: "#FFCF54"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97186 9.72766C9.77771 9.72766 9.6203 9.88507 9.6203 10.0792V15.0626C9.6203 15.2568 9.77771 15.4142 9.97186 15.4142C10.166 15.4142 10.3234 15.2568 10.3234 15.0626V10.0792C10.3234 9.88507 10.166 9.72766 9.97186 9.72766Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.6148C24 20.9772 23.7061 21.2711 23.3438 21.2711H0.65625C0.475313 21.2711 0.31125 21.1975 0.192187 21.0789C0.0735938 20.9603 0 20.7963 0 20.6148C0 20.252 0.293906 19.9581 0.65625 19.9581H23.3438C23.5247 19.9581 23.6887 20.0317 23.8078 20.1503C23.9264 20.2694 24 20.4334 24 20.6148Z",
    fill: "#D77D41"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8078 20.1503C23.9264 20.2694 24 20.4334 24 20.6148C24 20.9772 23.7061 21.2711 23.3438 21.2711H22.0781C22.4405 21.2711 22.7344 20.9772 22.7344 20.6148C22.7344 20.4334 22.6608 20.2694 22.5422 20.1503C22.4231 20.0317 22.2591 19.9581 22.0781 19.9581H23.3438C23.5247 19.9581 23.6887 20.0317 23.8078 20.1503Z",
    fill: "#B5612A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5781 5.64714L17.0569 3.84667L18.0666 3.55652L18.5841 5.35792L17.5781 5.64714Z",
    fill: "#FFCF54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/icon-library.c5a40bd53f7cb31534a9e58219c0a0be.svg";
export { ForwardRef as ReactComponent };